import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Select, Typography, Icon } from '@ts/storybook';
import { IconButton } from '@mui/material';

import { getSetting } from '@utils/helpers';

let Pagination = props => {
  // let numPages   = Math.ceil(props.numRows / props.itemsPerPage);
  // let activePage = Math.min(numPages, props.activePage);
  let numPages, rowEnd, rowStart;
  let activePage = props.activePage;

  if (props.numRows === null) {
    // we don't know the total count of the result
    if (props.activePage === 1 && props.rowsLength === 0) activePage = 0;
    rowStart = (activePage - 1) * props.itemsPerPage;
    rowEnd = Math.min(rowStart + props.itemsPerPage, rowStart + props.rowsLength);
  } else {
    numPages = Math.ceil(props.numRows / props.itemsPerPage);
    activePage = Math.min(numPages, props.activePage);
    rowStart = (activePage - 1) * props.itemsPerPage;
    rowEnd = Math.min(rowStart + props.itemsPerPage, props.numRows);
  }

  let rowStr = `${props.t('Showing 0 elements')}`;
  if (activePage > 0) {
    const showingRangeStr = `${rowStart + 1}-${rowEnd}`;
    const ofStr = props.numRows === null ? '' : `${props.t('of')} ${props.numRows} ${props.t('elements')}`;
    rowStr = `${props.t('Showing')} ${showingRangeStr} ${ofStr}`;
  }

  const rtl = props.lng == 'ar';
  const shouldDisablePrevPage = activePage <= 1;

  function shouldDisableNextPage() {
    let shouldDisable = false;
    if (!props.numRows) {
      if (props.rowsLength <= props.itemsPerPage) {
        shouldDisable = true;
      }
    } else {
      // we know the real count
      shouldDisable = activePage == numPages;
    }

    return shouldDisable;
  }

  const styleFooter = {
    position: props.noStickyFooter ? 'relative' : 'sticky',
    bottom: '0px',
    backgroundColor: '#ffffff',
    borderTop: '1px gainsboro solid',
    marginLeft: '0px',
    paddingLeft: '10px',
    paddingTop: '10px',
  };

  return (
    <Grid
      id="tableV3-footer"
      container
      size={12}
      spacing={2}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={styleFooter}
    >
      <Grid className="w-[150px]">
        <ItemsPerPage value={props.itemsPerPage} onChange={props.onItemsPerPageChange} t={props.t} />
      </Grid>
      <Grid>
        <Typography variant="caption" alignContent="center" color="#009688" text={rowStr} />
      </Grid>
      <Grid>
        <IconButton onClick={props.onPrevPage} disabled={props.isLoading || shouldDisablePrevPage}>
          <Icon icon={rtl ? 'navigation-chevron-right' : 'navigation-chevron-left'} />
        </IconButton>
        <IconButton onClick={props.onNextPage} disabled={props.isLoading || shouldDisableNextPage()}>
          <Icon icon={rtl ? 'navigation-chevron-left' : 'navigation-chevron-right'} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

Pagination.propTypes = {
  onNextPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  activePage: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  onItemsPerPageChange: PropTypes.func.isRequired,
  numRows: PropTypes.number,
  rowsLength: PropTypes.number,
  noStickyFooter: PropTypes.bool,
};

let ItemsPerPage = props => {
  const options = [
    { value: 2, label: `2 ${props.t('per page')}` },
    { value: 5, label: `5 ${props.t('per page')}` },
    { value: 10, label: `10 ${props.t('per page')}` },
    { value: 20, label: `20 ${props.t('per page')}` },
    { value: 25, label: `25 ${props.t('per page')}` },
  ];
  const settingRowPerPage = getSetting('rowsPerPage');
  if (settingRowPerPage && options.indexOf(settingRowPerPage) == -1) {
    options.sort((a, b) => a - b);
  }

  return (
    <Select
      label={props.t('Items per page')}
      widthOptions={150}
      onChange={props.onChange}
      options={options}
      value={props.value}
      sx={{ bottom: '8px' }}
    />
  );
};

export default withTranslation()(Pagination);
